import baseUrl from "../config/baseUrl";

const permanentlyDeleteDocument = async ({ token, id }) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/permanant-delete-document-table-data?document_id=${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default permanentlyDeleteDocument;
